import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M24.49 53.653h247.173v163.453a7.974 7.974 0 0 1-7.973 7.974H32.464a7.974 7.974 0 0 1-7.974-7.974z"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M267.676 57.64h-239.2v159.466a3.987 3.987 0 0 0 3.988 3.987H263.69a3.987 3.987 0 0 0 3.986-3.987zM24.49 53.653v163.453a7.974 7.974 0 0 0 7.974 7.974H263.69a7.974 7.974 0 0 0 7.973-7.974V53.653z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      d="M24.49 34.126a6.505 6.505 0 0 1 6.505-6.505h234.163a6.505 6.505 0 0 1 6.505 6.505v19.513H24.49zM24.49 108.274a2.6 2.6 0 0 1 2.602-2.602h241.969a2.6 2.6 0 0 1 2.602 2.602v1.301a2.6 2.6 0 0 1-2.602 2.601H27.092a2.6 2.6 0 0 1-2.602-2.601zM24.49 166.822a2.6 2.6 0 0 1 2.602-2.602h241.969a2.6 2.6 0 0 1 2.602 2.602v1.3a2.6 2.6 0 0 1-2.602 2.602H27.092a2.6 2.6 0 0 1-2.602-2.602z"
    />
    <path
      fill="#E2E2EB"
      d="M103.626 222.76a2.6 2.6 0 0 1-2.602-2.602V56.243a2.6 2.6 0 0 1 2.602-2.601h1.301a2.6 2.6 0 0 1 2.602 2.601v163.915a2.6 2.6 0 0 1-2.602 2.602zM188.942 222.76a2.6 2.6 0 0 1-2.602-2.602V56.243a2.6 2.6 0 0 1 2.602-2.601h1.301a2.6 2.6 0 0 1 2.601 2.601v163.915a2.6 2.6 0 0 1-2.601 2.602z"
    />
    <path
      stroke="#E2E2EB"
      strokeWidth={3.987}
      d="M26.491 55.647h243.187v161.459a5.98 5.98 0 0 1-5.98 5.98H32.471a5.98 5.98 0 0 1-5.98-5.98z"
    />
  </svg>
);
export default SvgTable;
